import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  TableCell,
  TableRow,
  MenuItem,
  Typography,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableContainer
} from '@material-ui/core';
import MaterialTable from 'material-table';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert';
import { startOfMonth, endOfMonth, addMonths } from 'date-fns';
import DateRangeSelectorComponent from '../../InquiryRegistry/Utils/DateRangeSelector';
import Popover from '@material-ui/core/Popover';
import EventIcon from '@material-ui/icons/Event';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import moment from 'moment';
import { LoadingComponent } from './../../../../utils/newLoader';
import { Bold } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'FACTORYITEMDETAILREPORT';

const groupFactoryItems = (data) => {
  var item = data.reduce((routes, item) => {
    let routeGroup = routes.find((r) => r.routeName === item.routeName);
    if (!routeGroup) {
      routeGroup = { routeName: item.routeName, categories: [] };
      routes.push(routeGroup);
    }
    let categoryGroup = routeGroup.categories.find((c) => c.categoryName === item.categoryName);
    if (!categoryGroup) {
      categoryGroup = { categoryName: item.categoryName, items: [] };
      routeGroup.categories.push(categoryGroup);
    }
    categoryGroup.items.push(item);
    return routes;
  }, []);
  return item;
};

const options = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export default function FactoryItemDetailReport(props) {
  const [title, setTitle] = useState("Factory Item Detail Report");
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [ItemCategoryList, setItemCategoryList] = useState();
  const [factoryItems, setFactoryItems] = useState();
  const [itemRequestDetail, setItemRequestDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: '',
    itemCategoryID: 0,
    factoryItemID: 0,
    startDate: new Date().toISOString().substring(0, 10),
    endDate: new Date().toISOString().substring(0, 10)
  });
  const [factoryItemList, setFactoryItemList] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '0',
    factoryName: '0',
    startDate: '',
    endDate: '',
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [csvHeaders, SetCsvHeaders] = useState([]);

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
  }, [itemRequestDetail.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
  }, [itemRequestDetail.factoryID]);

  useEffect(() => {
    trackPromise(getAllActiveItemCategory());
  }, []);

  useEffect(() => {
    trackPromise(getfactoryItemsForDropDown());
  }, [itemRequestDetail.groupID, itemRequestDetail.factoryID, itemRequestDetail.itemCategoryID]);

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      itemCategoryID: 0,
      factoryItemID: 0
    });
  }, [itemRequestDetail.routeID]);

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      factoryItemID: 0
    });
  }, [itemRequestDetail.itemCategoryID]);

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: ''
    });
  }, [itemRequestDetail.factoryItemID]);


  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      itemCategoryID: 0,
      routeID: 0,
    });
  }, [itemRequestDetail.factoryID, itemRequestDetail.groupID]);
  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode === 'VIEWFACTORYITEMDETAILREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode === 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode === 'FACTORYDROPDOWN');

    setPermissions({
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setItemRequestDetail({
      ...itemRequestDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(itemRequestDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(itemRequestDetail.factoryID);
    setRouteList(routes);
  }

  async function getAllActiveItemCategory() {
    const result = await services.getAllActiveItemCategory();
    setItemCategoryList(result);
  }

  async function getfactoryItemsForDropDown() {
    const factoryItem = await services.getfactoryItemsByGroupIDFactoryIDItemCategoryID(
      itemRequestDetail.groupID,
      itemRequestDetail.factoryID,
      itemRequestDetail.itemCategoryID
    );
    setFactoryItems(factoryItem);
  }

  async function GetFactoryItemDetails() {
    let model = {
      groupID: parseInt(itemRequestDetail.groupID),
      factoryID: parseInt(itemRequestDetail.factoryID),
      routeID: parseInt(itemRequestDetail.routeID),
      itemCategoryID: parseInt(itemRequestDetail.itemCategoryID),
      factoryItemID: parseInt(itemRequestDetail.factoryItemID),
      registrationNumber: itemRequestDetail.registrationNumber,
      startDate: moment(itemRequestDetail.startDate.toString()).format().split('T')[0],
      endDate: moment(itemRequestDetail.endDate.toString()).format().split('T')[0]
    };
    getSelectedDropdownValuesForReport(model);

    const itemData = await services.GetFactoryItemDetailsForReport(model);

    if (itemData.statusCode === 'Success' && itemData.data != null) {
      setFactoryItemList(itemData.data);
      createDataForExcel(itemData.data);
      if (itemData.data.length === 0) {
        alert.error('No records to display');
      }
    } else {
      alert.error(itemData.message);
    }
  }

  async function createDataForExcel(array) {
    var res = [];
    let maxNoOfInstallment = getMaxInstallmentCountFromAllRecords(array);

    if (array != null) {
      array.sort((a, b) => {
        if (a.routeName !== b.routeName) {
          return a.routeName.localeCompare(b.routeName);
        }
        return a.categoryName.localeCompare(b.categoryName);
      });

      let currentRoute = null;
      let currentCategory = null;
      let routeTotal = 0;
      let routeQuantityTotal = 0;
      let categoryTotal = 0;
      let categoryQuantityTotal = 0;

      array.forEach((x, index) => {
        let itemNoOfInstallments = x.noOfInstallments || 0;
        let itemTotalPrice = x.totalPrice || 0;
        let eachInstallmentValue = itemNoOfInstallments > 0 ? itemTotalPrice / itemNoOfInstallments : 0;

        if (currentRoute !== x.routeName) {
          if (currentRoute !== null) {
            if (categoryQuantityTotal > 0 || categoryTotal > 0) {
              res.push({
                '': `${currentCategory} Total`,
                'Quantity': categoryQuantityTotal,
                'Total Price (Rs)': categoryTotal
              });
            }
          }
          res.push({});
          res.push({
            '': `Route: ${x.routeName}`
          });

          currentRoute = x.routeName;
          routeTotal = 0;
          routeQuantityTotal = 0;
          currentCategory = null;
        }

        if (currentCategory !== x.categoryName) {
          if (currentCategory !== null) {
            res.push({
              '': `${currentCategory} Total`,
              'Quantity': categoryQuantityTotal,
              'Total Price (Rs)': categoryTotal
            });
          }
          res.push({
            '': `Category: ${x.categoryName}`
          });
          currentCategory = x.categoryName;
          categoryTotal = 0;
          categoryQuantityTotal = 0;
        }

        let vr = {
          '': '',
          'Created Date': x.date.split('T')[0],
          'Issuing Date': x.issuingDate.split('T')[0],
          'Effective Month': x.paymentEffectedMonth + '-' + x.paymentEffectedYear,
          'Reg No': x.registrationNumber,
          'Supplier Name': x.name,
          'Category': x.categoryName,
          'Item': x.itemName,
          'Quantity': x.approvedQuantity,
          'Total Price (Rs)': x.totalPrice,
          'Installments': x.noOfInstallments
        };

        for (let i = 0; i < maxNoOfInstallment; i++) {
          let excelColumnPropertyName = getOrdinalName(i + 1) + ' installment';
          vr[excelColumnPropertyName] = i + 1 <= itemNoOfInstallments ? eachInstallmentValue : '-';
        }

        res.push(vr);

        routeTotal += x.totalPrice;
        categoryTotal += x.totalPrice;
        routeQuantityTotal += x.approvedQuantity;
        categoryQuantityTotal += x.approvedQuantity;

        if (index === array.length - 1) {
          res.push({
            '': `${currentCategory} Total`,
            'Quantity': categoryQuantityTotal,
            'Total Price (Rs)': categoryTotal
          });
          
        }
      });

      res.push({});
      res.push({
        '': 'Group :' + selectedSearchValues.groupName,
        'Created Date': 'Factory :' + selectedSearchValues.factoryName
      });
      res.push({
        '': 'From :' + selectedSearchValues.startDate,
        'Created Date': 'To :' + selectedSearchValues.endDate
      });
    }

    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(factoryItemList);

    const maxNoOfInsatallment = getMaxInstallmentCountFromAllRecords(factoryItemList);
    const installmentColumns = Array.from({ length: maxNoOfInsatallment }).map((_, i) => `${getOrdinalName(i + 1)} installment`);

    const excelColumnOrder = [
      '',
      'Created Date',
      'Issuing Date',
      'Effective Month',
      'Reg No',
      'Supplier Name',
      'Category',
      'Item',
      'Quantity',
      'Installments'
    ];

    const desiredOrder = [...excelColumnOrder, ...installmentColumns, 'Total Price (Rs)'];
    const tempcsvHeaders = desiredOrder.map(col => ({ label: col, value: col }));

    var settings = {
      sheetName: 'Factory Item Detail Report',
      fileName: 'Factory Item Detail Report ' +
        selectedSearchValues.groupName +
        ' - ' +
        selectedSearchValues.factoryName +
        ' - ' +
        ((itemRequestDetail.routeID !== 0 && itemRequestDetail.routeID !== '')
          ? routeList[itemRequestDetail.routeID]
          : 'All Routes') +
        ' - ' +
        selectedSearchValues.startDate +
        ' - ' +
        selectedSearchValues.endDate,
      writeOptions: {}
    };

    let dataA = [
      {
        sheet: 'Factory Item Detail Report',
        columns: tempcsvHeaders,
        content: file
      }
    ];
    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setItemRequestDetail({
      ...itemRequestDetail,
      [e.target.name]: value
    });
    setFactoryItemList([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    var startDate = moment(searchForm.startDate.toString()).format().split('T')[0];
    var endDate = moment(searchForm.endDate.toString()).format().split('T')[0];
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      startDate: [startDate],
      endDate: [endDate],
      routeName: routeList[searchForm.routeID]
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  const getPageMargins = () => {
    return `@media print {
            @page {
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  function getMaxInstallmentCountFromAllRecords(responseData) {
    let maxNoOfInstallment = responseData.map(data => Number(data.noOfInstallments) || 0);
    return maxNoOfInstallment.length ? Math.max(...maxNoOfInstallment) : 0
  }

  function getOrdinalName(n) {
    const ordinals = ['1st', '2nd', '3rd', '4th'];
    return ordinals[n - 1] || `${n}th`
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: itemRequestDetail.groupID,
              factoryID: itemRequestDetail.factoryID,
              startDate: itemRequestDetail.startDate,
              endDate: itemRequestDetail.endDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
              factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
              startDate: Yup.string(),
              endDate: Yup.string()
            })}
            onSubmit={() => trackPromise(GetFactoryItemDetails())}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size="small"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="itemCategoryID">
                              Item Category
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="itemCategoryID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.itemCategoryID}
                              size="small"
                              variant="outlined"
                            >
                              <MenuItem value={0}>--Select Item Category--</MenuItem>
                              {generateDropDownMenu(ItemCategoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryItemID">
                              Factory Item
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="factoryItemID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.factoryItemID}
                              variant="outlined"
                              id="factoryItemID"
                              size="small"
                            >
                              <MenuItem value="0">--Select Factory Item--</MenuItem>
                              {generateDropDownMenu(factoryItems)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="registrationNumber"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                              size="small"
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="startDate">
                              From Date *
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="startDate"
                              type="date"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.startDate}
                              variant="outlined"
                              id="startDate"
                              size="small"
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="endDate">
                              To Date *
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="endDate"
                              type="date"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.endDate}
                              variant="outlined"
                              id="endDate"
                              size="small"
                            />
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2}>
                          <Button color="primary" type="submit" variant="contained" size="small">
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box style={{ minWidth: 1050, padding: 3 }}>
                        {factoryItemList.length > 0 &&
                          groupFactoryItems(factoryItemList).map((routeGroup) => (
                            <Fragment key={routeGroup.routeName}>
                              <Typography variant="h5" style={{ fontWeight: "bold", color: "#333", marginBottom: 10 }}>
                                Route: {routeGroup.routeName}
                              </Typography>

                              {routeGroup.categories.map((categoryGroup) => {
                                const totalQuantity = categoryGroup.items.reduce((sum, item) => sum + item.approvedQuantity, 0);
                                const totalPrice = categoryGroup.items.reduce((sum, item) => sum + item.totalPrice, 0);
                                const maxCols = getMaxInstallmentCountFromAllRecords(factoryItemList);

                                return (
                                  <Fragment key={categoryGroup.categoryName}>
                                    <Typography variant="h6" style={{ marginBottom: 10 }}>
                                      Category: {categoryGroup.categoryName}
                                    </Typography>

                                    <TableContainer component={Paper} style={{ marginBottom: 20, maxWidth: '100%', overflowX: 'auto' }}>
                                      <Table style={{ tableLayout: "fixed", minWidth: "100%", width: 'max-content', margin: 'auto' }}>
                                        <TableHead>
                                          <TableRow>
                                            <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 100, position: 'sticky', left: 0, background: '#fff', zIndex: 2 }}>Created Date</TableCell>
                                            <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 100, position: 'sticky', left: 100, background: '#fff', zIndex: 2 }}>Issuing Date</TableCell>
                                            <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 100, position: 'sticky', left: 200, background: '#fff', zIndex: 2 }}>Effective Month</TableCell>
                                            <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 80, position: 'sticky', left: 300, background: '#fff', zIndex: 2 }}>Reg No.</TableCell>
                                            <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 120, position: 'sticky', left: 380, background: '#fff', zIndex: 2 }}>Supplier Name</TableCell>
                                            <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 100, position: 'sticky', left: 500, background: '#fff', zIndex: 2 }}>Item</TableCell>
                                            <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 100, position: 'sticky', left: 600, background: '#fff', zIndex: 2 }}>Quantity</TableCell>
                                            <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 100, position: 'sticky', left: 700, background: '#fff', zIndex: 2 }}>No of Installments</TableCell>
                                            <TableCell colSpan={maxCols} style={{ textAlign: "center", fontWeight: 'bold', minWidth: maxCols * 100, background: '#fff', zIndex: 1 }}>Installments</TableCell>
                                            <TableCell rowSpan={2} style={{ textAlign: "right", fontWeight: 'bold', minWidth: 120, position: 'sticky', right: 0, background: '#fff', zIndex: 2 }}>Total Price (Rs)</TableCell>
                                          </TableRow>
                                          <TableRow>
                                            {Array.from({ length: maxCols }).map((_, index) => (
                                              <TableCell key={index} style={{ textAlign: "center", fontWeight: 'bold', minWidth: 100, background: '#fff', zIndex: 1 }}>
                                                {getOrdinalName(index + 1)}
                                              </TableCell>
                                            ))}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {categoryGroup.items.map((item, index) => {
                                            const installmentCount = Number(item.noOfInstallments) || 0;
                                            const total = Number(item.totalPrice) || 0;
                                            const installmentValue = installmentCount > 0 ? total / installmentCount : 0;
                                            return (
                                              <TableRow key={index}>
                                                <TableCell style={{ textAlign: "center", position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>{item.date.split("T")[0]}</TableCell>
                                                <TableCell style={{ textAlign: "center", position: 'sticky', left: 100, background: '#fff', zIndex: 1 }}>{item.issuingDate.split("T")[0]}</TableCell>
                                                <TableCell style={{ textAlign: "center", position: 'sticky', left: 200, background: '#fff', zIndex: 1 }}>{item.paymentEffectedMonth+'-'
                                                + item.paymentEffectedYear || '-'}</TableCell>
                                                <TableCell style={{ textAlign: "center", position: 'sticky', left: 300, background: '#fff', zIndex: 1 }}>{item.registrationNumber}</TableCell>
                                                <TableCell style={{ textAlign: "left", position: 'sticky', left: 380, background: '#fff', zIndex: 1 }}>{item.name}</TableCell>
                                                <TableCell style={{ textAlign: "center", position: 'sticky', left: 500, background: '#fff', zIndex: 1 }}>{item.itemName}</TableCell>
                                                <TableCell style={{ textAlign: "center", position: 'sticky', left: 600, background: '#fff', zIndex: 1 }}>{item.approvedQuantity}</TableCell>
                                                <TableCell style={{ textAlign: "center", position: 'sticky', left: 700, background: '#fff', zIndex: 1 }}>{item.noOfInstallments}</TableCell>
                                                {Array.from({ length: maxCols }).map((_, colIndex) => (
                                                  <TableCell key={colIndex} style={{ textAlign: "center", minWidth: 100 }}>
                                                    {colIndex + 1 <= installmentCount
                                                      ? installmentValue.toLocaleString("en-US", { minimumFractionDigits: 2 })
                                                      : '-'
                                                    }
                                                  </TableCell>
                                                ))}
                                                <TableCell style={{ textAlign: "right", position: 'sticky', right: 0, background: '#fff', zIndex: 1 }}>
                                                  {Number(item.totalPrice).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                                </TableCell>
                                              </TableRow>
                                            )
                                          })}
                                          <TableRow>
                                            <TableCell style={{ fontWeight: "bold", textAlign: "center", position: 'sticky', left: 0, background: '#fff', zIndex: 1 }}>Total</TableCell>
                                            <TableCell colSpan={5}></TableCell>
                                            <TableCell style={{ fontWeight: "bold", textAlign: "center", position: 'sticky', left: 600, background: '#fff', zIndex: 1 }}>{totalQuantity}</TableCell>
                                            <TableCell colSpan={maxCols + 1}></TableCell>
                                            <TableCell style={{ fontWeight: "bold", textAlign: "right", position: 'sticky', right: 0, background: '#fff', zIndex: 1 }}>{totalPrice.toFixed(2)}</TableCell>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Fragment>
                                );
                              })}
                            </Fragment>
                          ))}
                      </Box>
                      {factoryItemList.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={'Factory Item Detail Report ' +
                              selectedSearchValues.groupName +
                              ' - ' +
                              selectedSearchValues.factoryName +
                              ' - ' +
                              ((itemRequestDetail.routeID !== 0 && itemRequestDetail.routeID !== '')
                                ? routeList[itemRequestDetail.routeID]
                                : 'All Routes') +
                              ' - ' +
                              selectedSearchValues.startDate +
                              ' - ' +
                              selectedSearchValues.endDate}
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              factoryItemList={factoryItemList}
                              searchData={selectedSearchValues}
                              groupFactoryItems={groupFactoryItems}
                              getMaxInstallmentCountFromAllRecords={getMaxInstallmentCountFromAllRecords}
                              getOrdinalName={getOrdinalName}
                            />
                          </div>
                        </Box>
                      ) : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}


